import React from 'react';

interface IProps {
  fillColor?: string;
  style?: any;
}

export const ArrowLeftIcon:React.FC<IProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="1 0 24 24" style={props.style}>
      <path fill={props.fillColor ? props.fillColor : "#fff"} d="M16 7.4L11.4 12l4.6 4.6-1.4 1.4-6-6 6-6L16 7.4z"/>
    </svg>
  )
}